import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app/bookmark-filled",
  "use": "app/bookmark-filled-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"app/bookmark-filled\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M3.25.25h17.5v23.461l-8.717-8.034L3.25 23.7V.25z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol